import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { isEmptyCollection, isEmpty } from 'app/shared/helpers/utils';
import { MsAdalAngular6Service } from 'microsoft-adal-angular6';
import { HelperService } from '../helper/helper.service';

@Injectable()
export class AuthGuard implements CanActivate {
  
  constructor(private _router: Router, 
              private _adalSvc: MsAdalAngular6Service,
              private  _helperService: HelperService) 
  { }
 
  canActivate(route: ActivatedRouteSnapshot): boolean {
    if(!this._adalSvc.isAuthenticated) {
      this._router.navigate(['/login']);
      return false;
    } 
    if(this.validateRole(route.data.module)) {
      return true;
    } 
    this._router.navigate(['/sessions/401']);
    return false;
  }

  validateRole(menuCodigo: string) {
    let respuesta = false;
    let expectedRoles = this._helperService.getItemSessionStorage("listaRolMenu");
    let rolCodigo = this._helperService.getItemSessionStorage("codigoRol");
    if(isEmpty(menuCodigo)) {
      return true;
    }
    if(isEmptyCollection(expectedRoles)) {
      return false;
    }
    for(let role of expectedRoles) {
      if(role.menuCodigo == menuCodigo && role.rolCodigo == rolCodigo) {
        respuesta = true;
        break;
      }
    }
    return respuesta;
  }
}